// Fold a completed/paused turn once. Later updates preserve the person's
// choice to inspect it; a resumed agent opens a new stretch of work.
export default {
  mounted() {
    this.executionState = this.el.dataset.executionState
    this.el.open = this.executionState !== "stopped"
  },
  updated() {
    const state = this.el.dataset.executionState
    if (state !== this.executionState) {
      this.el.open = state !== "stopped"
      this.executionState = state
    }
  },
}
